import React from "react";
import { observer } from "mobx-react";
import { Col, Row } from "antd";
import CarriagePaymentRow from "./Row";

const CarriagePayments: React.FC = () => (
  <>
    <b>20.</b>
    <Row>
      <Col span={6}>To be paid by</Col>
      <Col span={6}>Sender</Col>
      <Col span={6}>Curency</Col>
      <Col span={6}>Consignee</Col>
    </Row>
    <CarriagePaymentRow name={["payments", "carriage"]} title="Carriage" />
    <CarriagePaymentRow name={["payments", "deductions"]} title="Deductions" />
    <CarriagePaymentRow name={["payments", "balance"]} title="Balance" />
    <CarriagePaymentRow
      name={["payments", "charges"]}
      title="Supplem, charges"
    />
    <CarriagePaymentRow
      name={["payments", "miscellaneous"]}
      title="Miscellaneous +"
    />
    <CarriagePaymentRow name={["payments", "total"]} title="Total to be paid" />
  </>
);

export default observer(CarriagePayments);
